(ns common.fields.field
  (:require [schema.core :as s]
            [potpuri.core :as potpuri]
            [common.fields.ui-modules :refer [ui-modules]]))

(def sys-admin-setting {:sa.d/no  :disabled-not-used
                        :sa.d/yes :disabled-in-use
                        :sa/no    :not-used
                        :sa/yes   :in-use})

(def tenant-admin-setting {:ta.d/no  :disabled-not-used
                           :ta.d/yes :disabled-in-use
                           :ta/no    :not-used
                           :ta/yes   :in-use})

(def external-guest-setting {:ex.d/no :disabled-not-used
                             :ex.d/r  :disabled-read-only
                             :ex.d/rw :disabled-in-use
                             :ex/no   :not-used
                             :ex/r    :read-only
                             :ex/rw   :in-use
                             nil      :not-used})

(def user-setting {:user.d/no :disabled-not-used
                   :user.d/r  :disabled-read-only
                   :user.d/rw :disabled-in-use
                   :user/no   :not-used
                   :user/r    :read-only
                   :user/rw   :in-use
                   nil        :not-used})

(def internal-guest-setting {:in.d/no :disabled-not-used
                             :in.d/r  :disabled-read-only
                             :in.d/rw :disabled-in-use
                             :in/no   :not-used
                             :in/r    :read-only
                             :in/rw   :in-use
                             nil      :not-used})

(def webentry-setting {:we.d/no        :disabled-not-used
                       :we.d/yes       :disabled-in-use
                       :we.d/mandatory :disabled-mandatory
                       :we/no          :not-used
                       :we/yes         :in-use
                       :we/mandatory   :mandatory
                       nil             :not-used})

(defn resolve-setting [settings allowed-map]
  (let [allowed-keys (keys allowed-map)
        res (filter #(some #{%} allowed-keys) settings)
        setting (first res)]
    (assert (< (count res) 2))
    (get allowed-map setting)))

(defn plain-setting [field-setting]
  (case field-setting
    :disabled-not-used :not-used
    :disabled-in-use :in-use
    :disabled-mandatory :mandatory
    :not-in-use :not-used
    field-setting))

(defn create-field-schema [default-module field settings ui-opts]
  (let [modules-used (merge (or (:other-modules ui-opts) []) default-module)
        modules-found (every? (set ui-modules) modules-used)]
    ; (assert modules-found (str "Could not find all modules for field " field " < " modules-used))
    ; (assert modules-used (str "No configured fields for field " field " < " default-module))
    {field {:webentry-visibility       (resolve-setting settings webentry-setting)
            :disabled-by-tenant-admin? (resolve-setting settings tenant-admin-setting)
            :disabled-by-sys-admin?    (resolve-setting settings sys-admin-setting)
            :user                      (resolve-setting settings user-setting)
            :external-guest            (resolve-setting settings external-guest-setting)
            :internal-guest            (resolve-setting settings internal-guest-setting)
            :ui-modules                modules-used
            }}))
